import type { LibraryBlocksState } from './library-blocks.reducer';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { groupBy } from '@common/helpers';
import { LIBRARY_BLOCKS_FEATURE_KEY, libraryBlocksAdapter } from './library-blocks.reducer';
import { LibraryBlockCategory, TempStatus } from '@web/store/library-blocks/library-blocks.models';

// Lookup the 'LibraryBlocks' feature state managed by NgRx
export const selectLibraryBlocksState = createFeatureSelector<LibraryBlocksState>(LIBRARY_BLOCKS_FEATURE_KEY);

const { selectAll, selectEntities } = libraryBlocksAdapter.getSelectors();

export const selectLibraryBlocksLoaded = createSelector(
    selectLibraryBlocksState,
    (state: LibraryBlocksState) => state.loaded
);

export const selectLibraryBlocksError = createSelector(
    selectLibraryBlocksState,
    (state: LibraryBlocksState) => state.error
);

export const selectAllLibraryBlocks = createSelector(selectLibraryBlocksState, (state: LibraryBlocksState) =>
    selectAll(state)
);

export const selectAllSavedLibraryBlocks = createSelector(selectLibraryBlocksState, (state: LibraryBlocksState) => {
    const libraryBlocks = selectAll(state);
    return libraryBlocks.filter(
        (block) => block.tempStatus !== TempStatus.new && block.tempStatus !== TempStatus.deleted
    );
});

export const selectLibraryBlocksEntities = createSelector(selectLibraryBlocksState, (state: LibraryBlocksState) =>
    selectEntities(state)
);

export const selectSelectedId = createSelector(
    selectLibraryBlocksState,
    (state: LibraryBlocksState) => state.selectedId
);

export const selectSelected = createSelector(selectLibraryBlocksEntities, selectSelectedId, (entities, selectedId) =>
    selectedId ? entities[selectedId] : undefined
);

export const selectLibraryBlock = (blockId: string) =>
    createSelector(selectLibraryBlocksEntities, (entities) => entities[blockId]);

export const selectGroupedLibraryBlocks = createSelector(selectAllSavedLibraryBlocks, (libraryBlocks) => {
    return groupBy(libraryBlocks, (block) => block.categoryIds[0] ?? LibraryBlockCategory.saved);
});
